import { controllerModel } from 'shared';

import { CHARTER_FLIGHT_DESCRIPTION_BOTTOM_SHEET } from './config';

export const useCharterFlightBottomSheet = () => {
  const bottomSheet = controllerModel.useBottomSheet();

  return {
    name: CHARTER_FLIGHT_DESCRIPTION_BOTTOM_SHEET,
    show: () => bottomSheet.show(CHARTER_FLIGHT_DESCRIPTION_BOTTOM_SHEET),
    hide: () => bottomSheet.hide(CHARTER_FLIGHT_DESCRIPTION_BOTTOM_SHEET),
  };
};
